// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-about-indexstyleGrid-container-bwork{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-about-indexstyleGrid-grid-bjnyc{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-about-indexstyleGrid-col6-bvpui{grid-column:span 6}.pages-company-about-indexstyleGrid-col3-bmuay{grid-column:span 3}.pages-company-about-indexstyleGrid-col4-btugj{grid-column:span 4}.pages-company-about-indexstyleGrid-col9-zbreh{grid-column:span 9}.pages-company-about-indexstyleGrid-col12-bpwvo{grid-column:span 12}.pages-company-about-indexstyleGrid-alignItemsStart-vstkb{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-about-indexstyleGrid-container-bwork",
	"grid": "pages-company-about-indexstyleGrid-grid-bjnyc",
	"col6": "pages-company-about-indexstyleGrid-col6-bvpui",
	"col3": "pages-company-about-indexstyleGrid-col3-bmuay",
	"col4": "pages-company-about-indexstyleGrid-col4-btugj",
	"col9": "pages-company-about-indexstyleGrid-col9-zbreh",
	"col12": "pages-company-about-indexstyleGrid-col12-bpwvo",
	"alignItemsStart": "pages-company-about-indexstyleGrid-alignItemsStart-vstkb"
};
module.exports = ___CSS_LOADER_EXPORT___;
